module.exports = __webpack_public_path__ + "static/titan-in-the-outfield-c5203fec381e07146ddf9a87fea74bfb.jpg";